import React, { useState, useEffect } from "react";
import axios from "axios";

const Campaign = () => {
  const [form, setForm] = useState({
    programmeName: "",
    campaignName: "",
    isActive: "",
  });

  const [campaigns, setCampaigns] = useState([]);
  const [selected, setSelected] = useState([]);
  const [editId, setEditId] = useState(null); // ✅ Track which campaign is being edited

  // ✅ Fetch all campaigns
  useEffect(() => {
    fetchCampaigns();
  }, []);

  const fetchCampaigns = async () => {
    try {
      const res = await axios.get("https://crm-server-htk6.vercel.app/api/campaigns");
      setCampaigns(res.data);
    } catch (err) {
      console.error("⚠️ Error fetching campaigns:", err);
    }
  };

  // ✅ Handle input
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  // ✅ Save new campaign
  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.programmeName || !form.campaignName) {
      alert("Please fill Programme Name and Campaign Name");
      return;
    }

    try {
      const res = await axios.post("https://crm-server-htk6.vercel.app/api/campaigns", form);
      if (res.data.success) {
        alert("✅ Campaign saved successfully");
        fetchCampaigns();
        resetForm();
      }
    } catch (err) {
      console.error("❌ Error saving campaign:", err);
    }
  };

  // ✅ Start editing
  const handleEdit = (c) => {
    setForm({
      programmeName: c.programmeName,
      campaignName: c.campaignName,
      isActive: c.isActive,
    });
    setEditId(c._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Update campaign
  const handleUpdate = async () => {
    if (!form.programmeName || !form.campaignName) {
      alert("Please fill Programme Name and Campaign Name");
      return;
    }

    try {
      await axios.put(`https://crm-server-htk6.vercel.app/api/campaigns/${editId}`, form);
      alert("✨ Campaign updated successfully");
      fetchCampaigns();
      resetForm();
    } catch (err) {
      console.error("❌ Error updating campaign:", err);
    }
  };

  const resetForm = () => {
    setForm({
      programmeName: "",
      campaignName: "",
      isActive: "",
    });
    setEditId(null);
  };

  // ✅ Select checkbox
  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((s) => s !== id) : [...prev, id]
    );
  };

  // ✅ Select All
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelected(campaigns.map((c) => c._id));
    } else {
      setSelected([]);
    }
  };

  // ✅ Delete one
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure to delete this campaign?")) return;
    try {
      await axios.delete(`https://crm-server-htk6.vercel.app/api/campaigns/${id}`);
      fetchCampaigns();
      setSelected((prev) => prev.filter((s) => s !== id));
    } catch (err) {
      console.error("❌ Error deleting campaign:", err);
    }
  };

  // ✅ Bulk delete
  const handleBulkDelete = async () => {
    if (selected.length === 0) {
      alert("⚠️ Please select at least one campaign to delete");
      return;
    }
    if (!window.confirm(`Delete ${selected.length} selected campaigns?`)) return;

    try {
      await axios.delete("https://crm-server-htk6.vercel.app/api/campaigns", {
        data: { ids: selected },
      });
      setSelected([]);
      fetchCampaigns();
    } catch (err) {
      console.error("❌ Error bulk deleting campaigns:", err);
    }
  };

  return (
    <div className="page" style={{ fontFamily: "Arial, sans-serif", padding: "20px" }}>
      <h2 style={{ textAlign: "center", color: "#2a9d8f" }}>Campaign Management</h2>

      {/* Campaign Create / Update Form */}
      <div
        className="form-container"
        style={{
          background: "#f8f9fa",
          padding: "20px",
          borderRadius: "10px",
          marginBottom: "20px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#264653" }}>
          {editId ? "✏️ Update Campaign" : "Create New Campaign"}
        </h3>

        <div className="form-row" style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
      {/* Programme Name Input + Datalist */}
<input
  list="programmeOptions"
  name="programmeName"
  value={form.programmeName}
  onChange={handleChange}
  placeholder="Type or select a Program"
  required
  style={{ flex: 1, padding: "8px" }}
/>

<datalist id="programmeOptions">
  {[
    ...new Set(
      campaigns.map(c => c.programmeName || c.name || "")
    )
  ].filter(v => v)   // remove empty strings
   .map((uniqueName, idx) => (
      <option key={idx} value={uniqueName} />
   ))}
</datalist>


          <input
            type="text"
            name="campaignName"
            placeholder="Campaign Name"
            value={form.campaignName}
            onChange={handleChange}
            style={{ flex: 2, padding: "8px" }}
          />
        </div>

        <div className="form-row" style={{ display: "flex", gap: "20px", marginBottom: "15px" }}>
         
          <label>
            <input type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} /> Is Active
          </label>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={editId ? handleUpdate : handleSave}
            style={{
              background: editId ? "#e9c46a" : "#2a9d8f",
              color: "white",
              padding: "10px 16px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              flex: 1,
            }}
          >
            {editId ? "✏️ Update Campaign" : "💾 Save Campaign"}
          </button>

          {editId && (
            <button
              onClick={resetForm}
              style={{
                background: "#e63946",
                color: "white",
                padding: "10px 16px",
                borderRadius: "6px",
                border: "none",
                cursor: "pointer",
                flex: 1,
              }}
            >
              ❌ Cancel
            </button>
          )}
        </div>
      </div>

      {/* List Header with Bulk Delete */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
        <h3 className="list-title" style={{ margin: 0 }}>📋 Campaign List</h3>
        <button
          onClick={handleBulkDelete}
          style={{
            background: selected.length > 0 ? "#e63946" : "gray",
            color: "white",
            padding: "8px 16px",
            borderRadius: "6px",
            border: "none",
            cursor: selected.length > 0 ? "pointer" : "not-allowed",
          }}
          disabled={selected.length === 0}
        >
          🗑 Delete Selected ({selected.length})
        </button>
      </div>

      {/* Table */}
      <div className="table-container" style={{ overflowX: "auto" }}>
        <table className="user-table" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ background: "#f4f4f4" }}>
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={handleSelectAll}
                  checked={campaigns.length > 0 && selected.length === campaigns.length}
                />
              </th>
              <th>Campaign Name</th>
              <th>Programme Name</th>
              <th>Is Active</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {campaigns.length === 0 ? (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "12px" }}>
                  No Campaigns Found
                </td>
              </tr>
            ) : (
              campaigns.map((c) => (
                <tr key={c._id} style={{ borderBottom: "1px solid #ddd" }}>
                  <td style={{ textAlign: "center" }}>
                    <input type="checkbox" checked={selected.includes(c._id)} onChange={() => toggleSelect(c._id)} />
                  </td>
                  <td>{c.campaignName}</td>
                  <td>{c.programmeName}</td>
                  <td>{c.isActive ? "Yes" : "No"}</td>
                  <td style={{ textAlign: "center" }}>
  <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
    <button
      onClick={() => handleEdit(c)}
      style={{
        background: "#457b9d",
        color: "white",
        border: "none",
        padding: "5px 10px",
        borderRadius: "4px",
        cursor: "pointer",
      }}
    >
      ✏️ Edit
    </button>
    <button
      onClick={() => handleDelete(c._id)}
      style={{
        background: "#e63946",
        color: "white",
        border: "none",
        padding: "5px 10px",
        borderRadius: "4px",
        cursor: "pointer",
      }}
    >
      🗑 Delete
    </button>
  </div>
</td>

                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Campaign;
